module.exports = __webpack_public_path__ + "img/USA_RED_MEATS.282daf53.png";